<template>
  <div id="app">
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
  </div>
</template>

<script>
export default {
	name: 'App',
	mounted(){
    // this.checkLogin();
  },
	methods:{
		checkLogin(){
      let user_token = window.localStorage.getItem('user_token')
      if(!user_token){
        this.$router.replace({ path: '/login'});
      }
    },
	}
}
</script>

<style lang='scss'>
  .el-table .warning-row {
    background: #f8f9fa;
  }
  html,body {
	margin: 0px;
	padding: 0px;
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
}

#app {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
}

.fade-enter-active,
.fade-leave-active {
	transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}
.ql-editor{
  min-height:400px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue